var imagePathMOD = 'https://yakima-production.s3.amazonaws.com/mod/';
var rootPath = window.location.href;
var rootApiUrl = 'https://api-au.yakima.com/api';
var currentSku = '';
var pageLoaded = false;
var discountAmount = 0;
var activeFit = localStorage.getItem('fitId');
var marketId = 3;


if (rootPath.indexOf('nz.') >= 0 || rootPath.indexOf('.nz') >= 0)
    marketId = 4;

if (rootPath.indexOf('www.yakima.com') >= 0)
    rootPath = 'https://www.yakima.com';


jQuery(document).ready(function ($) {

   discountAmount = 0;// GetDiscountAmount();

    currentSku = $('.sku').first().text().replace('SKU: #', '');
    showMODSystem();
    loadFit();
    pageLoaded = true;
    if(window.location.href.indexOf('showCart=1') >= 0) {
       jQuery('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden');
      removeQueryStringFromUrl();
    }
});
function removeQueryStringFromUrl() {
  const url = new URL(window.location.href);
  url.search = '';
  window.history.replaceState({}, document.title, url.toString());
}
function getPriceText(price) {
// var discount = readCookie("discount_code");
 // if(discountAmount > 0 &&  parseFloat(price) > 0) {
 //   var discountPrice = parseFloat(price) * ((100 - discountAmount) / 100);
 //	return '<del>$' +  parseFloat(price).toFixed(2) + '</del> <span class="red">$' + discountPrice.toFixed(2) + '</span>'; 
 // }
//  else 
    return parseFloat(price).toLocaleString("en-US", { style: "currency", currency: "USD" });
}

function loadFit() {
  var vehicleId = localStorage.getItem('vehicleId');
  if(vehicleId == null) {
    jQuery('#fitCurrentVehicle').html('<p><span style="color: #CCCCCC;">&#149;</span> Is this product compatible with your vehicle?&nbsp;&nbsp; <a href="#" class="fmc">Add Your Vehicle</a></p>');
    jQuery('a.fmc').bind("click tap", function (e) {
        fmcModalInit();

        e.preventDefault();
    });
  }
  else {
   var url = rootApiUrl + '/fitcheck/MODMeasurements/' + localStorage.getItem('vehicleId') + '/Europe';
    console.log(url);
    jQuery('.system-fit-options--option.nofit').removeClass('nofit');
    jQuery.get(url, function (modData) {
        if (typeof modData == 'object') {
          
           jQuery.each(modData, function (i, data) {
           if(data.noFit) {
             if(data.notes.length > 0) {
                url = rootApiUrl + '/fitnote/GetFitNotes/' + data.id + '/';
                jQuery.get(url, function (data) {
                  console.log('fitnotes', data);
                  var fitnotes = '';
                    jQuery.each(data, function (i, e) {
                        fitnotes += '<p><span style="color: Yellow;">•</span>' + e.note + '</p>';
                    });
                  jQuery('#fitCurrentVehicle').html(fitnotes);
                });
                  jQuery('.mod-option').removeClass('nofit');
             }
             else {
                        jQuery('#fitCurrentVehicle').html('<p><span style="color: Red;">•</span>Unfortunately your vehicle is not compatible with the MOD System.</p>');
                  jQuery('.mod-option').addClass('nofit');
               
             }
           }
           else {
              console.log('moddata', data);
             // alert(data);
             if(data.level1HomeBaseMedium == 0) {
               jQuery('#hb-medium').addClass('nofit');
               jQuery('.mod-fridge-options').show();
               
             }
             else {
               jQuery('#hb-medium').addClass('selected');
               
              jQuery('.mod-fridge-options').hide();
               if(data.baseHomeBaseMedium == 0) jQuery('.mod-homebase-options').hide();
               if(data.level2TopperMedium == 0) 
                 jQuery('.mod-topper-options input').addClass('nofit');
               else
                 if(data.level3TopperMedium == 0) jQuery('.mod-topper-options input').addClass('nothird');
               if(data.level2ToteMedium == 0) 
                 jQuery('.mod-tote-options input').addClass('nofit');
               else
                 if(data.level3ToteMedium == 0) jQuery('.mod-tote-options input').addClass('nothird');
               if(data.level2CrateMedium == 0) 
                 jQuery('.mod-crate-options input').addClass('nofit');
               else
                 if(data.level3CrateMedium == 0) jQuery('.mod-crate-options input').addClass('nothird');
             }
             if(data.level1HomeBaseLarge == 0) 
               jQuery('#hb-large').addClass('nofit');
             else {
               jQuery('#hb-large').addClass('selected');
               if(data.baseHomeBaseLarge == 0) jQuery('.mod-homebase-options').hide();
               if(data.level2TopperLarge == 0) 
                 jQuery('.mod-topper-options input').addClass('nofit');
               else
                 if(data.level3TopperLarge == 0) jQuery('.mod-topper-options input').addClass('nothird');
               
               if(data.level2ToteLarge == 0) 
                 jQuery('.mod-tote-options input').addClass('nofit');
               else
                 if(data.level3ToteLarge == 0) jQuery('.mod-tote-options input').addClass('nothird');
               if(data.level2CrateLarge == 0) 
                 jQuery('.mod-crate-options input').addClass('nofit');
               else
                 if(data.level3CrateLarge == 0) jQuery('.mod-crate-options input').addClass('nothird');
             }

               
            
             if(data.riserKitRequired == 1) jQuery('#accessory-riserkit').addClass('selected');
             if(data.fitKitNumber == 1) {
               jQuery('#accessory-fitkit').addClass('selected');
               if(data.fitKitQuantity == 2) jQuery('#accessory-fitkit select').val(2);
               
             }
            
            var level3 = data.level3CrateMedium + data.level3CrateLarge + data.level3ToteMedium + data.level3ToteLarge + data.level3TopperMedium + data.level3TopperLarge + data.level3TopperXL;
            localStorage.setItem('level3enabled', level3 > 0);
            jQuery('.mod-option.nofit').append('<span class="nofit">No Vehicle Fit</span>');
              var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
            setFitMessage('#64a70b', ' Fits your ' + vehName + '', 'fit');
             buildSummary();
           }
           
      });
        }
        else {
          jQuery('.mod-option').removeClass('disabled');
          jQuery('#fitCurrentVehicle').html('<p><span style="color: Yellow;">•</span>We cannot confirm compatibility with your vehicle. Please refer to "<a href=\'https://yakimaassets.s3.us-west-2.amazonaws.com/MOD-system-guidelines.pdf\'>MOD Guidelines & Best Practices</a>" to determine if your vehicle is suitable for a custom solution.</p>');
        }
    });
  }
}
function showMODSystem() {
    var vehName = localStorage.getItem('year') + ' ' + localStorage.getItem('make-name') + ' ' + localStorage.getItem('model-name');
    
    jQuery('.price-box .price').each(function () {
        jQuery(this).text('Starting at ' + jQuery(this).text());
    });

    var baseSelect = '<div id="base-section" class="tower-attachment"><div class="systems-fit-options--top"><h4 class="systems-fit-options--title">1. Pick Your Base</h4></div>';
    baseSelect += '<div class="system-fit-options--bottom"><div id="hb-medium" class="system-fit-options--option medium">61cm x 91cm (MD)</div><div id="hb-large" class="system-fit-options--option">85cm x 91cm (LG)</div><div id="hb-xl" class="system-fit-options--option">114cm x 91cm (XL)</div></div></div>';
    baseSelect += '<div class="mod-homebase-options"><h4 class="sub">Quantity</h4><input type="radio" class="checkbox" name="select-homebase" id="homebase-one" value="1" checked/>1<input type="radio" name="select-homebase" class="checkbox" id="homebase-two" value="2"/>2</div>';
      jQuery('.mod-options').append(baseSelect);
  

   var configurationSelect = '<div id="configuration-section" class="mod-optional"><div class="systems-fit-options--top"><h4 class="systems-fit-options--title">2. Configurations (Optional)</h4></div>';
    configurationSelect += '<div class="mod-topper-options"><h4 class="sub">Add a Topper</h4><input type="radio" class="checkbox" name="select-topper" id="topper-none" value="0" checked/>None<input type="radio" name="select-topper" class="checkbox" id="topper-one" value="1"/>1<input type="radio" name="select-topper" class="checkbox" id="topper-two" value="2"/>2</div>';
    configurationSelect += '<div class="mod-tote-options"><h4 class="sub">Add a Tote</h4><input type="radio" class="checkbox" name="select-tote" id="tote-none" value="0" checked/>None<input type="radio" class="checkbox" name="select-tote" id="tote-one" value="1"/>1<input type="radio" class="checkbox" name="select-tote" id="tote-two" value="2"/>2</div>';
    configurationSelect += '<div class="mod-crate-options"><h4 class="sub">Add a Crate</h4><input type="radio" class="checkbox" name="select-crate" id="crate-none" value="0" checked/>None<input type="radio" class="checkbox" name="select-crate" id="crate-one" value="1"/>1<input type="radio" class="checkbox" name="select-crate" id="crate-two" value="2"/>2</div></div>';
      jQuery('.mod-options').append(configurationSelect);

     var accessoriesSelect = '<div id="accessories-section" class="mod-optional"><div class="systems-fit-options--top"><h4 class="systems-fit-options--title">3. Accessories (Optional)</h4></div>';
    accessoriesSelect += '<div class="mod-fridge-options"><h4 class="sub">Add a Fridge Slide Mount</h4><input type="radio" class="checkbox" name="select-fridge" id="fridge-none" value="0" checked/>None<input type="radio" class="checkbox" name="select-fridge" id="fridge-one value="1""/>1</div>';
       accessoriesSelect += '<div class="mod-microtote-options"><h4 class="sub">Add a MicroTote</h4><input type="radio" class="checkbox" name="select-microtote" id="microtote-none" value="0" checked/>None<input type="radio" class="checkbox" name="select-microtote" id="microtote-one" value="1"/>1<input type="radio" class="checkbox" name="select-microtote" id="microtote-two" value="2"/>2</div>';
    accessoriesSelect += '<div class="mod-workspace-options"><h4 class="sub">Add a WorkSpace</h4><input type="radio" class="checkbox" name="select-workspace" id="workspace-none" value="0" checked/>None<input type="radio" class="checkbox" name="select-workspace" id="workspace-one" value="1"/>1<input type="radio" class="checkbox" name="select-workspace" id="workspace-two" value="2" disabled/>2</div></div>';
     accessoriesSelect += '<div class="mod-stretchnet-options"><h4 class="sub">Add a Stretch Net</h4><input type="radio" class="checkbox" name="select-stretchnet" id="stretchnet-none" value="0" checked/>None<input type="radio" class="checkbox" name="select-stretchnet" id="stretchnet-one" value="1"/>1</div></div>';
     accessoriesSelect += '<div class="mod-riserkit-options"><h4 class="sub">Add a Riser Kit</h4><input type="radio" class="checkbox" name="select-riserkit" id="riserkit-none" value="0" checked/>None<input type="radio" class="checkbox" name="select-riserkit" id="riserkit-one" value="1"/>1</div></div>';
 
    jQuery('.mod-options').append(accessoriesSelect);
  
  
    var vehicleId = localStorage.getItem('vehicleId');
    jQuery('.mod-options').append('<div class="system-summary"><h3>MOD Summary</h3><div class="content"></div>');
    jQuery('.mod-options .system-summary .content').append('<div id="selected-hb" class="hb-options section"></div>');

    if(localStorage.getItem('model-name'))
      jQuery('.mod-options .system-summary .content').append('<h4>Parts Required for Assembly:</h4>');
    jQuery('.mod-options .system-summary .content').append('<div class="required-items section"></div><hr/><div id="mod-components"></div><div class="system-total section"></div>');
   // jQuery('.mod-options .system-summary .content .system-total').append('<span class="total label">Total</span><span class="total value"></span><span class="qty"></span><span class="total totalprice"></span>');
    jQuery('.mod-options .system-summary .content').append('<button type="button" title="Find a Dealer" class="button" id="mod-add-cart" onclick="FindDealer()"><span><span>' + (vehicleId == null ? 'Select your Vehicle' : 'Find A Dealer') + '</span></span></button><div class="clear"></div>');

    if (vehicleId == null || vehicleId == 0) {
        jQuery('.product-single .tower-options').first().prepend('<button type="button" title="Add Vehicle" class="button btn" id="tower-add-vehicle" onclick="fmcModalInit()"><span><span>Add Vehicle</span></span></button><div class="clear"></div>');
    }
    
  //  calculateTotals();

    fitCheck();
   
   jQuery('input[type=radio]').change(function () {
        setImage();
     changeBase();
        buildSummary();
     //  calculateTotals();
    // checkQuantities();
   //  e.stopPropagation();
    });
  jQuery('.system-fit-options--option').unbind().click(function () {
    if(!jQuery(this).hasClass('nofit')) {
        jQuery(this).parent().find('.selected').removeClass('selected');
        jQuery(this).addClass('selected');
        buildSummary();
        jQuery('.mod-fridge-options').show();
        if(jQuery(this).attr('id') == 'hb-medium')
          jQuery('.mod-fridge-options').hide();
    }
  });
  jQuery('#tower-add-cart').unbind().click(function (e) {
    
       addToCart();
     e.stopPropagation();
    });

}
function FindDealer() {
  window.location = '/pages/dealer-locator';
}
function changeBase() {
  var baseCnt = 1;
  
  jQuery('#configuration-section .checkbox').removeAttr("disabled");
  if(jQuery('#homebase-two').is(":checked")) {
    baseCnt = 2;
    jQuery('input[type=radio].nothird').attr("disabled",true);
    jQuery('#workspace-two').attr("disabled",false);
  }
  else {
    jQuery('input[type=radio].nothird').removeAttr("disabled");
    jQuery('#workspace-two').attr("disabled",true);
  }
    
  if(jQuery('input[name="select-topper"]:checked').val() == 2) {
    jQuery('input[name="select-tote"]').attr("disabled",true);
    jQuery('input[name="select-crate"]').attr("disabled",true);
  }
  else if(jQuery('input[name="select-tote"]:checked').val() == 2) {
    jQuery('input[name="select-topper"]').attr("disabled",true);
    jQuery('input[name="select-crate"]').attr("disabled",true);
  }
  else if(jQuery('input[name="select-crate"]:checked').val() == 2) {
    jQuery('input[name="select-tote"]').attr("disabled",true);
    jQuery('input[name="select-topper"]').attr("disabled",true);
  }
  else if(jQuery('input[name="select-topper"]:checked').val() == 1) {
    jQuery('#tote-two').attr("disabled",true);
    jQuery('#crate-two').attr("disabled",true);
    if(jQuery('input[name="select-tote"]:checked').val() == 1) { jQuery('#crate-one').attr("disabled",true); jQuery('#topper-two').attr("disabled",true); }
    if(jQuery('input[name="select-crate"]:checked').val() == 1) { jQuery('#tote-one').attr("disabled",true); jQuery('#topper-two').attr("disabled",true); }
  }
  else if(jQuery('input[name="select-tote"]:checked').val() == 1) {
    jQuery('#topper-two').attr("disabled",true);
    jQuery('#crate-two').attr("disabled",true);
    if(jQuery('input[name="select-topper"]:checked').val() == 1) { jQuery('#crate-one').attr("disabled",true); jQuery('#tote-two').attr("disabled",true); }
    if(jQuery('input[name="select-crate"]:checked').val() == 1) { jQuery('#topper-one').attr("disabled",true); jQuery('#tote-two').attr("disabled",true); }
  }
  else if(jQuery('input[name="select-crate"]:checked').val() == 1) {
    jQuery('#tote-two').attr("disabled",true);
    jQuery('#crate-two').attr("disabled",true);
    if(jQuery('input[name="select-tote"]:checked').val() == 1) { jQuery('#topper-one').attr("disabled",true); jQuery('#topper-two').attr("disabled",true); }
    if(jQuery('input[name="select-topper"]:checked').val() == 1) { jQuery('#tote-one').attr("disabled",true); jQuery('#topper-two').attr("disabled",true); }
  }  
}
function checkQuantities() {
  var level2 = 0;
  var level3enabled = localStorage.getItem('level3enabled') != 'false';
  var level3 = 0;
  var modcnt = 2;
  var tops = 0;
  var crates = 0;
  var totes = 0;

  var hb = localStorage.getItem('mod-homebase').replace('hb-', '');
  jQuery('.mod-option.disabled').each(function() {
    
    if(!jQuery(this).hasClass('nofit') && jQuery(this).hasClass(hb)) jQuery(this).removeClass('disabled');
   });
  jQuery('.mod-option p.qty.hide').removeClass('hide');
  jQuery('.mod-option p.qty select').prop('disabled', false);
  jQuery('.mod-option.nosecond').removeClass('nosecond');
  
  if (jQuery('.mod-option.home.selected').length) {
    
    if(parseInt(jQuery('.mod-option.home.selected').find('p.qty select').val()) == 2)  {
      level2 = 2;
      jQuery('.mod-option.top').addClass('disabled');
    }
    else if (jQuery('.mod-option.top.selected').length) {
      tops = parseInt(jQuery('.mod-option.top.selected').find('p.qty select').val());
      if(tops == 1) {
        jQuery('.mod-option.tote').addClass('nosecond').find('p.qty').addClass('hide').find('select').prop('disabled', 'disabled');
        jQuery('.mod-option.crate').addClass('nosecond').find('p.qty').addClass('hide').find('select').prop('disabled', 'disabled');
      }
      if(tops == 2 && !level3enabled) {
        jQuery('.mod-option.tote').addClass('disabled');
        jQuery('.mod-option.crate').addClass('disabled');
      }
      else if(tops == 2) tops = 0;
    }
    
    if (jQuery('.mod-option.crate.selected').length) {
      crates = parseInt(jQuery('.mod-option.crate.selected').find('p.qty select').val());
      if(crates + tops >= 2)
        jQuery('.mod-option.tote').addClass('disabled');
      else
        jQuery('.mod-option.tote').addClass('nosecond').find('p.qty').addClass('hide').find('select').prop('disabled', 'disabled');
    }
    if (jQuery('.mod-option.tote.selected').length) {
      totes = parseInt(jQuery('.mod-option.tote.selected').find('p.qty select').val());
      console.log('totes', jQuery('.mod-option.tote.selected').find('p.qty select').val());
      if(totes + tops >= 2)
        jQuery('.mod-option.crate').addClass('disabled');
      else
        jQuery('.mod-option.crate').addClass('nosecond').find('p.qty').addClass('hide').find('select').prop('disabled', 'disabled');
    }
    
  }
  
}
function buildSummary() {
  var sumhtml = '';
  var base = jQuery('#base-section .system-fit-options--option.selected').first().attr('id');
  var homebaseMd = 1079;
  var homebaseLg = 1279;
  var homebaseXl = 1279;
  var topperMd = 749;
  var topperLg = 879;
  var riser = 85;
  var fitkit = 25;
  var workspace = 99;
  var fridgeSlide = 109;
  var stretchNet = 59;
  if(marketId == 4) {
    homebaseMd = 1179;
    homebaseLg = 1379;
    topperMd = 829;
    topperLg = 959;
    riser = 95;
    fitkit = 30;
    workspace = 109;
    fridgeSlide = 119;
    stretchNet = 69;
  }

  if(base == 'hb-medium') {
    sumhtml = '<span class="summary-item" data-id="41172594917424" data-price="' + homebaseMd + '" data-qty="' + ($('input[name="select-homebase"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'hb-medium.png"></img><h4>HomeBase MD</h4><span class="qty">Qty:' + ($('input[name="select-homebase"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
    if($('input[name="select-topper"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172609335344" data-price="' + topperMd + '" data-qty="' + ($('input[name="select-topper"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'topper-medium.png"></img><h4>Topper MD</h4><span class="qty">Qty:' + ($('input[name="select-topper"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
   if($('input[name="select-tote"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172648394800" data-price="79" data-qty="' + ($('input[name="select-tote"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'tote-medium.png"></img><h4>GearTote MD</h4><span class="qty">Qty:' + ($('input[name="select-tote"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
    if($('input[name="select-crate"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172659011632" data-price="169" data-qty="' + ($('input[name="select-crate"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'crate-medium.png"></img><h4>GearCrate MD</h4><span class="qty">Qty:' + ($('input[name="select-crate"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';

  }
  if(base == 'hb-large') { 
    sumhtml = '<span class="summary-item" data-id="41172596359216" data-price="' + homebaseLg + '" data-qty="' + ($('input[name="select-homebase"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'hb-large.png"></img><h4>HomeBase LG</h4><span class="qty">Qty:' + ($('input[name="select-homebase"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
    if($('input[name="select-topper"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172610809904" data-price="' + topperLg + '" data-qty="' + ($('input[name="select-topper"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'topper-large.png"></img><h4>Topper LG</h4><span class="qty">Qty:' + ($('input[name="select-topper"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
    if($('input[name="select-tote"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172649017392" data-price="99" data-qty="' + ($('input[name="select-tote"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'tote-large.png"></img><h4>GearTote LG/XL</h4><span class="qty">Qty:' + ($('input[name="select-tote"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
    if($('input[name="select-crate"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172656783408" data-price="199" data-qty="' + ($('input[name="select-crate"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'crate-large.png"></img><h4>GearCrate LG/XL</h4><span class="qty">Qty:' + ($('input[name="select-crate"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';

  }
  if(base == 'hb-xl') {
    sumhtml = '<span class="summary-item" data-id="41172599111728" data-price="' + homebaseXl + '" data-qty="' + ($('input[name="select-homebase"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePath + 'hb-xl.png"></img><h4>HomeBase XL</h4><span class="qty">Qty:' + ($('input[name="select-homebase"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
    if($('input[name="select-topper"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172611301424" data-price="849" data-qty="' + ($('input[name="select-topper"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePath + 'topper-xl.png"></img><h4>Topper XL</h4><span class="qty">Qty:' + ($('input[name="select-topper"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
    if($('input[name="select-tote"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172649017392" data-price="99" data-qty="' + ($('input[name="select-tote"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePath + 'tote-large.png"></img><h4>GearTote LG/XL</h4><span class="qty">Qty:' + ($('input[name="select-tote"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
    if($('input[name="select-crate"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172656783408" data-price="199" data-qty="' + ($('input[name="select-crate"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePath + 'crate-large.png"></img><h4>GearCrate LG/XL</h4><span class="qty">Qty:' + ($('input[name="select-crate"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';

  }
  if($('input[name="select-fridge"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172222672944" data-price="' + fridgeSlide + '" data-qty="' + ($('input[name="select-fridge"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'mod-fridge-slide.png"></img><h4>Fridge Slide Kit</h4><span class="qty">Qty:' + ($('input[name="select-fridge"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
  if($('input[name="select-microtote"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41570532065328" data-price="79" data-qty="' + ($('input[name="select-microtote"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'mod-micro-totes.png"></img><h4>MicroTotes</h4><span class="qty">Qty:' + ($('input[name="select-microtote"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
  if($('input[name="select-workspace"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172642562096" data-price="' + workspace + '" data-qty="' + ($('input[name="select-workspace"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'mod-work-space.png"></img><h4>Work Space</h4><span class="qty">Qty:' + ($('input[name="select-workspace"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
  if($('input[name="select-stretchnet"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172642562096" data-price="' + stretchNet + '" data-qty="' + ($('input[name="select-stretchnet"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'mod-stretchnet.png"></img><h4>Stretch Net</h4><span class="qty">Qty:' + ($('input[name="select-stretchnet"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';
  if($('input[name="select-riserkit"]:checked').val() != "0") sumhtml += '<span class="summary-item" data-id="41172642562096" data-price="' + riser + '" data-qty="' + ($('input[name="select-riserkit"]:checked').val() == '2' ? '2' : '1') + '"><img src="' + imagePathMOD + 'riserkit.png"></img><h4>Riser Kit</h4><span class="qty">Qty:' + ($('input[name="select-riserkit"]:checked').val() == '2' ? '2' : '1') + '</span><span class="price"></span></span>';

  jQuery('#tower-add-cart').removeClass('disabled').html('<span><span>Find A Dealer</span></span>');
  jQuery('#mod-components').html(sumhtml);
  calculateTotals();
}
function summaryInventory() {
    if (localStorage.getItem('partnerId') === null && localStorage.getItem('ipCountry') != 'ca') {
        jQuery('.system-summary .required').each(function () {
          var summaryItem = jQuery(this);
            var sku = jQuery(this).attr('data-sku');

            if (sku && sku.length > 0) {
                var url = rootApiUrl + '/inventory/GetInventoryValue/' + sku;
              console.log(url);
                jQuery.get(url, function (data) {
                    if (data <= 0) {
                      
                        jQuery(summaryItem).first().addClass('oos');
                        jQuery(summaryItem).find('.price').first().text('Out of Stock');
                    }
                });
            }

        });
    }

}

function setImage() {
  var base = 'mod-1homebase';
  var img = 'mod-1homebase';
  
  if($('input[name="select-homebase"]:checked').val() == "2") {
    base = 'mod-1homebase-2homebase';
    img = base;
  }

  var idx = (base.indexOf('2homebase') < 0) ? '2' : '3';

  if($('input[name="select-topper"]:checked').val() == "1") {
    img = base + '-' + idx + 'topper';
  }
  
  if($('input[name="select-topper"]:checked').val() == "2") {
    img = base + '-' + idx + 'toppers';
    idx = '3';
    base = 'mod-1homebase-2toppers';
  }

   if($('input[name="select-crate"]:checked').val() == "1") {
    if(img.indexOf('-' + idx) < 0) img = base + '-' + idx;
    img = img + 'gearcrate';
  }
  if($('input[name="select-crate"]:checked').val() == "2") {
    if(img.indexOf('-' + idx) < 0) img = base + '-' + idx;
    img = img + 'gearcrates';
  }

  if($('input[name="select-tote"]:checked').val() == "1") {
    if(img.indexOf('-' + idx) < 0) img = base + '-' + idx;
     img = img + 'geartote';
  }
  if($('input[name="select-tote"]:checked').val() == "2") {
    if(img.indexOf('-' + idx) < 0) img = base + '-' + idx;
     img = img + 'geartotes';
  }

  if($('input[name="select-fridge"]:checked').val() != "0") {
     img = 'mod-fridge-slide';
  }


  if($('input[name="select-workspace"]:checked').val() != "0") {
     img = 'mod-work-space';
  }
  
  img = 'http://d2amiavn18tu8z.cloudfront.net/mod/' + img + '.png';
  console.log(img);
  jQuery('#mod-image').first().attr('src', img);
}



function calculateTotals() {
    var total = 0;
    jQuery('.system-summary .summary-item').each(function () {
          var priceText = jQuery(this).find('.price').text();
          var qty = jQuery(this).attr('data-qty');
          if (priceText.length > 0 && priceText != 'Out of Stock' && jQuery(this).css('display') !== 'none') {
            var price = parseFloat(priceText.replace('$', '').replace(',', ''));
            if(qty != '' && qty != '1')
              price = price * parseFloat(qty);
            total = total + price;
          }
    });

    jQuery('.system-summary .totalprice').first().html(getPriceText(total));
}

function addToCart() {
    if (!jQuery('#tower-add-cart').hasClass('disabled')) {

        var store = '';
      var productName =  $('.product-single__title').first().text();
      var totalPrice =   parseFloat($('.system-total .totalprice').first().text().replace('$', '').replace(',', ''));
      
        if (window.location.href.indexOf('/ca') > 0)
            store = '/ca';
      
		jQuery('#tower-add-cart')
          .css('background-color', '#666')
          .find('span')
          .text('Added');

      dataLayer.push({
                ecommerce: null
            }); 
            
            dataLayer.push({
                event: "gtmEcommerceEvent",
                eventName: "add_to_cart",
                eventCategory: "ecommerce",
                eventAction: "add to cart",
                eventLabel: productName,
                nonInteractionHit: false,
                ecommerce: {
                    items: [{
                        item_id: currentSku,
                        item_name: productName,
                        affiliation: "Yakima Store",
                        coupon: null, 
                        currency: "USD",
                        discount: 0,
                        item_brand: "Yakima",
                        item_category: null, 
                        item_category2: null, 
                        item_category3: null, 
                        item_category4: null, 
                        item_category5: null, 
                        item_variant: "Default",
                        price: totalPrice,
                        quantity: 1
                    }]
                }
            });
      var cartItems = [];
        jQuery('#mod-components .summary-item').each(function (idx) {
          
        var sku = jQuery(this).find('.sku').text();
        var name = jQuery(this).find('h4').text();
          
        var price = jQuery(this).attr('data-price');
        var id = jQuery(this).attr('data-id');
        var qty = jQuery(this).attr('data-qty');

          idx = idx++;
      console.log('adding ' + id);
          cartItems.push({ 'id': id, 'quantity': qty });
          
        //   addProduct(jQuery(this).attr('data-id'), qty, idx);

          
            dataLayer.push({
                ecommerce: null
            }); 
            
            dataLayer.push({
                event: "gtmEcommerceEvent",
                eventName: "add_to_cart",
                eventCategory: "ecommerce",
                eventAction: "add to cart",
                eventLabel: name,
                nonInteractionHit: false,
                ecommerce: {
                    items: [{
                        item_id: sku,
                        item_name: name,
                        affiliation: "Yakima Store",
                        coupon: null, 
                        currency: "USD",
                        discount: 0,
                        item_brand: "Yakima",
                        item_category: null, 
                        item_category2: null, 
                        item_category3: null, 
                        item_category4: null, 
                        item_category5: null, 
                        item_variant: "Default",
                        price: price,
                        quantity: qty
                    }]
                }
            });
          
            localStorage.setItem('fitId', activeFit);
            localStorage.setItem('system-name', jQuery('.product-single__title').first().text().replace(' System', ''));

            if (('partnerId' in localStorage && localStorage.getItem('partnerId') !== 'null') || localStorage.getItem('ipCountry') == 'ca') {

                var cart = '';
                if (localStorage.getItem('cart-transfer'))
                    cart = localStorage.getItem('cart-transfer');

                if(localStorage.getItem('ipCountry') == 'ca')
                  price = jQuery(this).find('.caprice').text();
                localStorage.setItem('cart-transfer', cart + '|' + sku + ',1,' + price + ',' + name);
				SetCartCount();
            }

        });
        dataLayer.push({
            'event': 'fmcFitSelect',
            'action': 'new',
            'fmcFitId': '' + activeFit
        });

        var container = '<div id="fmc-modal-container" class="ajax-success-message modal-container active reversed"><div class="ajax-success-message modal-content"><div class="content">';

      if(jQuery('.system-summary .required.oos').length > 0) {
        var oosProducts = '';
        jQuery('.system-summary .required.oos').each(function () {
                oosProducts += '<br/>' + jQuery(this).find('h4').text() + ' (' + jQuery(this).attr('data-sku') + ')';

      		});
        	jQuery('body').first().append(container + '<p>Not all products can be added to your cart at this time - please find these products at your local dealer to complete your Yakima System<br/>' + oosProducts + '</p><div class="actions"><a onclick="reloadPage();" class="button reversed close">I Understand</a></div></div></div>');
      }

      if(cartItems.length > 0) {
            let cartItemList = { 'items': cartItems };
            console.log(cartItemList);
            addProducts(cartItemList, true);
        }
      
      //  else if ('partnerId' in localStorage && localStorage.getItem('partnerId') !== 'null')
    //        jQuery('body').first().append(container + '<h4 class="title">PRODUCTS HAVE BEEN ADDED TO YOUR CART</h4>We\'ve brought all of your products together so you can easily checkout. We hope you enjoy your next adventure with your Yakima products!</p><div class="actions"><a class="button reversed close" href="#" onclick="location.reload();">Continue Shopping</a></div></div></div>'); 
     //  else
         //   jQuery('body').first().append(container + '<h4 class="title">PRODUCTS HAVE BEEN ADDED TO YOUR CART</h4>We\'ve brought all of your products together so you can easily checkout. We hope you enjoy your next adventure with your Yakima products!</p><div class="actions"><a class="button reversed close" href="#" onclick="location.reload();">Continue Shopping</a><a href="/checkout" class="button reversed outline">Review And Checkout</a></div></div></div>'); 

console.log('added ' + jQuery('.related-products .details.cart').length + ' products');
      window.setTimeout(function() {
           //  location.reload();
      }, jQuery('.mod-option.selected').length * 300);
    }

}
function addProducts(cartItems, reload) {
 console.log(JSON.stringify(cartItems));
 
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cartItems)
    })
    .then(response => {
      if(reload)
         window.location = window.location.href + '?showCart=1';
      return response.json();
    })
    .catch((error) => {
      console.log('Error:', error);
    });
}
function addProduct(id, qty, idx) {
  window.setTimeout(function() {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: qty,
        id: id
      },
      dataType: 'json',
      success: function () {
        console.log('Product added to cart: ' + id + ' qty ' + qty);
      },
      error: function (xhr, ajaxOptions, thrownError) {
        console.log(xhr);
      }

    });  
  }, (idx + 1) * 150);
}
function callAjax(url, failCnt) {
    console.log(url);
    new Ajax.Request(url, {
        method: 'post',
        onFailure: function (response) {
            failCnt++;
            if (failCnt > 5)
                alert('Ajax call failed: ' + url);
            else
                callAjax(url, failCnt);
        }
    });
}